import { c as _c } from "react/compiler-runtime";
import { cva } from '@repo/panda/css';
import type React from 'react';
const tagStyles = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4',
    paddingY: '0',
    paddingX: '4',
    minWidth: 'fit',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    fontSize: 'xs',
    lineHeight: '[16px]',
    letterSpacing: '[0.5px]',
    textTransform: 'uppercase',
    fontWeight: 'medium'
  },
  variants: {
    variant: {
      default: {
        backgroundColor: 'white',
        color: 'gray.950'
      },
      inverse: {
        backgroundColor: 'gray.950',
        color: 'white'
      },
      ghost: {
        backgroundColor: 'whiteAlpha.20',
        color: 'text.primary'
      },
      brand: {
        backgroundColor: 'brand.primary',
        color: 'black'
      },
      success: {
        backgroundColor: 'success/15',
        color: 'success.300'
      },
      warning: {
        backgroundColor: 'warning/15',
        color: 'warning.300'
      },
      error: {
        backgroundColor: 'error/15',
        color: 'error.300'
      },
      info: {
        backgroundColor: 'info/15',
        color: 'info.300'
      }
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
export interface TagProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  as?: 'div' | 'span';
  variant?: 'default' | 'inverse' | 'ghost' | 'brand' | 'success' | 'warning' | 'error' | 'info';
}
export const Tag: React.FC<TagProps> = t0 => {
  const $ = _c(13);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as: t1,
      children,
      className,
      variant: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const Component = t1 === undefined ? "div" : t1;
  const variant = t2 === undefined ? "default" : t2;
  let t3;
  if ($[6] !== variant) {
    t3 = tagStyles({
      variant
    });
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const styles = t3;
  const combinedClassName = className ? `${styles} ${className}` : styles;
  let t4;
  if ($[8] !== Component || $[9] !== children || $[10] !== combinedClassName || $[11] !== props) {
    t4 = <Component className={combinedClassName} {...props}>{children}</Component>;
    $[8] = Component;
    $[9] = children;
    $[10] = combinedClassName;
    $[11] = props;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default Tag;